import Heading from "components/Typography/Heading"
import BodyText from "components/Typography/BodyText"
import styled from "styled-components"

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 112px;
  width: 100%;
`

interface CellTextProps {
  title?: string
  content?: string
}

export const CellText = (props: CellTextProps) => {
  const { title, content } = props

  return (
    <ContentColumn>
      <Heading variant="xs">{title}</Heading>
      <BodyText size="xs">{content}</BodyText>
    </ContentColumn>
  )
}
